import { render, staticRenderFns } from "./RemovePool.vue?vue&type=template&id=707b792e&scoped=true&"
import script from "./RemovePool.vue?vue&type=script&lang=js&"
export * from "./RemovePool.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "707b792e",
  null
  
)

export default component.exports